const PAYMENT_PLAN_HIGHLIGHT_TEXT_REPLACEMENTS: Record<string, string> = {
  'Schedule live onboarding session with of our reps!': 'Access our Guided Life Review: 85 prompts across 11 life areas'
};

export const normalizePaymentPlanHighlightText = (text: string): string => {
  return PAYMENT_PLAN_HIGHLIGHT_TEXT_REPLACEMENTS[text] ?? text;
};